import { isContentItemActiveInRange } from "./memberWeeklyContent";

export interface MemberCalendarContentItem {
  item_id: string;
  assignees: string[];
  content: string;
  completed: boolean;
  start_time: number;
  due_time: number;
  priority: "low" | "medium" | "high" | "urgent";
}

export interface MemberCalendarTask {
  id?: string;
  project_id: string;
  status?: string;
  phase?: "initiation" | "development" | "promotion" | "production";
  subtask_summary?: {
    items?: Array<{
      id?: string;
      title: string;
      reviewers: string[];
      content_items: MemberCalendarContentItem[];
    }>;
  };
}

export function getMemberCalendarContentDayStarts(
  contentItem: Pick<MemberCalendarContentItem, "start_time" | "due_time">,
  rangeStart: number,
  dayCount = 30
) {
  const dayMs = 24 * 60 * 60 * 1000;
  return Array.from({ length: dayCount }, (_, index) => rangeStart + index * dayMs)
    .filter((dayStart) =>
      isContentItemActiveInRange(contentItem, dayStart, dayStart + dayMs)
    );
}

export function selectMemberCalendarContentItems(
  tasks: MemberCalendarTask[],
  projectIds: ReadonlySet<string>,
  memberId: string,
  rangeStart: number,
  rangeEnd: number
) {
  return tasks
    .filter(
      (task) =>
        projectIds.has(task.project_id) && task.status !== "discarded"
    )
    .flatMap((task) =>
      (task.subtask_summary?.items || [])
        .flatMap((subtask) =>
          subtask.content_items
            .filter(
              (contentItem) =>
                contentItem.assignees.includes(memberId) &&
                isContentItemActiveInRange(contentItem, rangeStart, rangeEnd)
            )
            .map((contentItem) => ({
              task,
              subtask,
              contentItem,
              participantRole: "assignee" as const,
            }))
        )
    );
}
